import { useMemo } from 'react'

import type { ServiceForCanva } from './interface'
import { CanvaServiceConfigurations } from './serviceConfigurations'
import type { CanvaDesignConfig } from './serviceConfigurations'

export { CanvaDesignConfig }

const getCanvaDesignConfig = (
  serviceId: ServiceForCanva,
  isStoryPost?: boolean,
): CanvaDesignConfig => {
  if (isStoryPost) {
    return CanvaServiceConfigurations.instagramStory
  }

  const config = CanvaServiceConfigurations[serviceId]

  if (!config) throw new Error('Missing design option for canva')

  return config
}

export const getCanvaChannel = (serviceId: ServiceForCanva): string => {
  return serviceId === 'omni'
    ? 'multiple'
    : getCanvaDesignConfig(serviceId).service
}

export const useCanvaDesignConfig = (
  serviceId: ServiceForCanva,
  isStoryPost?: boolean,
): CanvaDesignConfig => {
  return useMemo(
    () => getCanvaDesignConfig(serviceId, isStoryPost),
    [serviceId, isStoryPost],
  )
}
